/* eslint-disable no-underscore-dangle */

import './accordion.css';
import React, { useContext } from 'react';
import BootstrapAccordion from 'react-bootstrap/Accordion';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';

/* >>>>>>>>>> MAIN <<<<<<<<<< */

type AccordionProps = React.ComponentProps<typeof BootstrapAccordion>;

function _Accordion(props: AccordionProps, ref: React.ForwardedRef<HTMLDivElement>) {
  return <BootstrapAccordion {...props} ref={ref} />;
}

const Accordion = React.forwardRef(_Accordion) as React.ForwardRefExoticComponent<
  AccordionProps & React.RefAttributes<HTMLDivElement>
>;

/* >>>>>>>>>> TOGGLE <<<<<<<<<< */

type AccordionToggleProps = React.ComponentProps<typeof BootstrapAccordion.Toggle> & {
  hasChevron?: boolean;
  eventKey: string;
  onClick?: (e: React.MouseEvent) => void;
};

function _AccordionToggle(
  { className = '', eventKey, hasChevron = false, onClick, ...props }: AccordionToggleProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const currentEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey);
  const customOnClick = (e: React.MouseEvent) => {
    decoratedOnClick(e);
    onClick?.(e);
  };

  const isCurrentEventKey = currentEventKey === eventKey;
  return (
    <BootstrapAccordion.Toggle
      className={`custom-accordion-toggle ${isCurrentEventKey ? 'open' : 'closed'} ${
        hasChevron ? 'collapsable-chevron' : ''
      } ${className}`}
      eventKey={eventKey}
      {...props}
      onClick={customOnClick}
      ref={ref}
    />
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AccordionToggle = React.forwardRef(_AccordionToggle as any) as React.ForwardRefExoticComponent<
  AccordionToggleProps & React.RefAttributes<HTMLDivElement>
>;

/* >>>>>>>>>> COLLAPSE <<<<<<<<<< */

type AccordionCollapseProps = React.ComponentProps<typeof BootstrapAccordion.Collapse>;

function _AccordionCollapse(props: AccordionCollapseProps, ref: React.ForwardedRef<HTMLDivElement>) {
  return <BootstrapAccordion.Collapse {...props} ref={ref} />;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AccordionCollapse = React.forwardRef(_AccordionCollapse as any) as React.ForwardRefExoticComponent<
  AccordionCollapseProps & React.RefAttributes<HTMLDivElement>
>;

/* >>>>>>>>>> EXPORT <<<<<<<<<< */

export default Object.assign(Accordion, {
  Toggle: AccordionToggle,
  Collapse: AccordionCollapse,
});
